/* ChildViewRenderer.js */

"use strict";
const _ = require("lodash");

class ChildViewRenderer {
    constructor(view) {
        this._view = view;
        this._rootElem = document.querySelector(
            "editor-layout-gl .lm_items > .lm_item_container.focused_item > .lm_content"
        );

        this._goBackIcon = document.createElement("base-icon-gl");
        this._goBackIcon.dataset.icon = "common.back";
        this._goBackIcon.classList.add("dark");
        this._goBackIcon.setAttribute("title", "Go Back");

        this._titleCmpnt = this.getHeaderElement(this._view.backLink, this._view.title);

        this._childViewElem = document.createElement("game-editor-gl");
        this._childViewElem.classList.add("child-view");

        /*jshint -W030 */
        view.css && this._childViewElem.classList.add(view.css);

        this._childViewElem.appendChild(this._titleCmpnt);
        this._childViewElem.appendChild(this._view.data);

        const callback = this._view.backCallback;
        if (callback instanceof Promise) {
            this._goBackCallback = () => callback;
        } else if (typeof callback === "function") {
            this._goBackCallback = () => Promise.resolve(callback());
        } else {
            this._goBackCallback = undefined;
        }

        this._rootElem.appendChild(this._childViewElem);
        if (this._view.backButton) {
            this._registerViewAction();
        }
        this.render();
        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        document.querySelectorAll(".child-view breadcrumb-gl").forEach((elem) => {
            elem.addEventListener(
                "click",
                (this._onGoBackIconUserClick = this._onGoBackIconUserClick.bind(this))
            );
        });
        this._view.childData.on("HideBackButton", () => {
            this._hideBackButton();
        });
        this._view.childData.on("showBackButton", () => {
            this._showBackButton();
        });
    }
    _unregisterListeners() {
        document.querySelectorAll(".child-view breadcrumb-gl").forEach((elem) => {
            elem.removeEventListener("click", this._onGoBackIconUserClick);
        });
    }
    _registerViewAction() {
        return new Promise((resolve) => {
            this._view.parentData._gameEditor.addViewAction({
                type: "normal",
                displayName: "Back",
                name: "BackButtonForChildView",
                handler: (this._onBackButtonClick = this._onBackButtonClick.bind(this)),
            });
            resolve();
        });
    }
    _hideViewAction() {
        if (this._view) {
            this._view.parentData._gameEditor.removeViewAction("BackButtonForChildView");
        }
    }

    _hideBackButton() {
        if (this._view) {
            this._view.parentData._gameEditor.hideViewAction("BackButtonForChildView");
        }
    }
    _showBackButton() {
        if (this._view) {
            this._view.parentData._gameEditor.showViewAction("BackButtonForChildView");
        }
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        if (_.get(this._view, "backButton", false)) {
            this._hideViewAction();
        }

        return Promise.resolve().then(() => {
            //TODO set all class members to undefined here
            if (this._view) {
                this._view.parentData.childViewOpen = undefined;
                this._view.parentData.childViewName = undefined;
            }
            this._view = undefined;
            if (this._titleCmpnt) {
                this._titleCmpnt.remove();
            }
            if (this._childViewElem) {
                this._childViewElem.remove();
            }

            this._titleCmpnt = undefined;
            this._childViewElem = undefined;
            this._goBackCallback = undefined;
        });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            this._view.parentData._renderer._hideViewActions();
            this._view.parentData._renderer._hideLeftFooterContainer();
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get titleComponent() {
        return this.getTitleCompnt();
    }
    getTitleCompnt() {
        return this._titleCmpnt;
    }

    getHeaderElement(backBtn = "", centerTitle = "") {
        let titleElement = document.createElement("game-editor-header-gl");
        titleElement.classList.add("ge-header");

        titleElement.insertAdjacentHTML(
            "afterbegin",
            `
                    <game-editor-header-left-content class='ge-header-left'>
                     <game-editor-breadcrumb-gl>
                        <breadcrumb-gl>
                            <breadcrumb-content-gl class="component_content">
                                <span>
                                    ${backBtn}
                                </span>
                            </breadcrumb-content-gl>
                        </breadcrumb-gl>
                    </game-editor-breadcrumb-gl>
                    </game-editor-header-left-content>
                    
                    <game-editor-header-middle-content class='ge-header-middle'>
                    ${centerTitle}
                    </game-editor-header-middle-content>
                    
                    <game-editor-header-right-content class='ge-header-right'>                                
                    </game-editor-header-right-content>
            `
        );

        // let titleIconElem = titleElement.querySelector("breadcrumb-gl");
        titleElement
            .querySelector("breadcrumb-gl")
            .insertAdjacentHTML("afterbegin", this._goBackIcon.outerHTML);

        return titleElement;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _onGoBackIconUserClick() {
        if (!this._view) {
            return;
        }

        if (this._goBackCallback) {
            return this._goBackCallback().then(() => {
                return this.shutdown();
            });
        } else {
            return this._closeChildView();
        }
    }

    _onBackButtonClick() {
        return this._closeChildView();
    }

    _closeChildView() {
        return this._view.childData.shutdown().then(
            () => {
                this._view.parentData.childViewOpen = undefined;
                this._view.parentData.childViewName = undefined;
                this._view.parentData._renderer._showViewActions();
                this._view.parentData._renderer._showLeftFooterContainer();
                this._view.parentData._renderer._refreshGrid();
                return this.shutdown();
            },
            () => undefined
        );
    }

    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = ChildViewRenderer;
